/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import CostsSecureIcon from "../../../../assets/icons/generic/IconCostSecurity";
import ContainerFullWidth from "../../../Container/ContainerFullWidth";
import trafficCostRiskSectionStyle from "./trafficCostRiskSectionStyle";
import { Box, Grid } from "@mui/material";
import Container from "../../../Container/Container";
import Typography from "@mui/material/Typography";

type TrafficCostRiskSectionProps = {
  sectionPadding?: boolean;
};

const TrafficCostRiskSection = ({ sectionPadding = false }: TrafficCostRiskSectionProps) => {
  return (
    <ContainerFullWidth sx={trafficCostRiskSectionStyle.noWinNoFeeSection} sectionPadding={sectionPadding}>
      <Box sx={trafficCostRiskSectionStyle.scrollToAnchor} id="kein-kostenrisiko" />
      <Typography variant={"h2"}>Fordern Sie Ihr Recht ein - komplett ohne Kostenrisiko!</Typography>
      <CostsSecureIcon sx={trafficCostRiskSectionStyle.costsSecureIcon} />
      <Container sectionPadding={false}>
        <Typography variant={"h4"} sx={trafficCostRiskSectionStyle.subHeadlineFirst}>
          Unser Versprechen an Sie
        </Typography>
        <Typography sx={trafficCostRiskSectionStyle.paragraphTop}>
          Wir geben Ihnen eine kostenlose Ersteinschätzung und sorgen dafür, dass Sie sich auch danach über die Kosten keine Sorgen machen müssen!
        </Typography>
        <Typography variant={"h4"} sx={trafficCostRiskSectionStyle.subHeadlineSecond}>
          So geht es nach der Prüfung weiter
        </Typography>
        <Grid container spacing={3}>
          <Grid item sm={12} md={8}>
            <Box sx={trafficCostRiskSectionStyle.box}>
              <Typography variant={"h6"} sx={trafficCostRiskSectionStyle.subHeadlineThird}>
                Ihr Bescheid ist fehlerhaft und kann angefochten werden
              </Typography>
              <Typography sx={trafficCostRiskSectionStyle.paragraph}>
                Wir setzen uns für die Einstellung des Verfahrens oder eine Reduzierung der Strafe ein. Die Kosten für Anwalt und Gericht trägt Ihre
                Rechtsschutzversicherung. Sie haben keine Versicherung? Dann klären wir vorab mit Ihnen alles zur Zahlung und halten die Kosten so gering wie
                möglich - keine Kosten ohne Absprache!
              </Typography>
            </Box>
          </Grid>
          <Grid item sm={12} md={4}>
            <Box sx={trafficCostRiskSectionStyle.box}>
              <Typography variant={"h6"} sx={trafficCostRiskSectionStyle.subHeadlineForth}>
                Bescheid ist korrekt und daher nicht anfechtbar
              </Typography>
              <Typography sx={trafficCostRiskSectionStyle.paragraph}>
                Sie erfahren direkt, wenn wir die Erfolgsaussichten für zu gering halten. So können Sie sich unnötige und hohe Kosten für Anwalt und Gericht
                sparen.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </ContainerFullWidth>
  );
};
export default TrafficCostRiskSection;
